import React from 'react';
import { useLocation } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import DesktopContainer from '../../containers/DesktopContainer';
import { useError } from '../../../error-provider/ErrorProvider';
import { GetAgentHistory } from '../../../graphql/queries/GetAgentHistory';

const MenuContainer = ({ title, children }) => {
    const location = useLocation();
    const { pathname } = location;
    const { showError } = useError();

    useQuery(GetAgentHistory, {
        variables: {
            callerPhoneNumber: '',
        },
        onError(error) {
            showError(undefined, error);
        },
    });

    // TODO: Reuse for rest pages
    const checkCurrentPage = (page, secondPath = '', thirdPath = '', fourthPath = '') => {
        function removeIdOrDigitsAfterSlash(inputString) {
            return inputString?.replace(/\/(:\w+|\d+)(\?|$)/, '/');
        }

        if (removeIdOrDigitsAfterSlash(pathname) === removeIdOrDigitsAfterSlash(page)) {
            return true;
        } else if (pathname === secondPath || pathname === thirdPath || pathname === fourthPath) {
            return true;
        } else {
            return false;
        }
    };

    return (
        <DesktopContainer title={title} checkCurrentPage={checkCurrentPage}>
            {children}
        </DesktopContainer>
    );
};

export default MenuContainer;
